export * from './sicherheitscheck.component';
export * from './sicherheitscheck.component.module';